import "./Blurb.css"
import parse from 'html-react-parser';
import { useState } from "react";

export default function Blurb({blurb, isHtml, blurbNoVanish=false}) {
	const [blurbAbbr, setBlurbAbbr] = useState(!blurbNoVanish);
	
   let visibleParas;
   if (blurb) {
      const visibleBlurbParagraphs = blurb.split("\n")
      visibleParas = []
	   let i = 0
      for (const blurbParagraph of visibleBlurbParagraphs) {
         // console.log(blurbParagraph)

         const para = `<p key=${i++}>` + blurbParagraph + "<br/><br/></p>"
         // console.log(parse(para))
         visibleParas.push(parse(para))
		 //  if(i === visableBlurbParagraphs.length && !blurbAbbr) {
			// visableParas.push()
			//
		 //  }
      }
	   

   }
   else if (isHtml) {
      visibleParas = blurb;
   }




   const blurbClass = "blurb"
	
	return (
		<div className={`blurb-container-${blurbAbbr ? "hidden" : "visible"}`}>
			<div className={`${blurbClass}`}onClick={() => setBlurbAbbr(false)}>
				{visibleParas}
			</div>
		</div>

	)
}
